
(() => {
  const BLOCK_SELECTOR = '[data-block-type="icons-with-text"]';
  const MAIN_SELECTOR = '#main'; // adapte si besoin (#MainContent)
 const DRAWER_ID = '_mainmodal_MxhnBM';

  const contentCache = new Map();
  const preloadCache = new Map();

  const isSameOriginUrl = (url) => {
    try {
      const parsed = new URL(url, window.location.href);
      return parsed.origin === window.location.origin;
    } catch {
      return false;
    }
  };

  const isEligibleHref = (href) => {
    if (!href) return false;
    if (href.startsWith('#')) return false;
    if (/^(mailto|tel|javascript):/i.test(href)) return false;
    return isSameOriginUrl(href);
  };

 const getDrawer = () =>
  document.querySelector(`[id$="${DRAWER_ID}"]`);

  const sanitizeRoot = (root) => {
    root.querySelectorAll('shop-cart-sync').forEach((el) => el.remove());
    root.querySelectorAll('iframe[src*="shop.app"]').forEach((el) => el.remove());
    root.querySelectorAll('script').forEach((el) => el.remove());
  };

  const extractMainContent = (htmlText) => {
    const doc = new DOMParser().parseFromString(htmlText, 'text/html');
    sanitizeRoot(doc);

    const main = doc.querySelector(MAIN_SELECTOR);
    if (!main) return null;

    sanitizeRoot(main);
    return main.innerHTML;
  };

  const preloadContent = (href) => {
    if (!isEligibleHref(href)) return Promise.resolve(null);
    if (contentCache.has(href)) return Promise.resolve(contentCache.get(href));
    if (preloadCache.has(href)) return preloadCache.get(href);

    const p = fetch(href, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.text() : null))
      .then((htmlText) => {
        if (!htmlText) return null;
        const mainContent = extractMainContent(htmlText);
        if (mainContent) contentCache.set(href, mainContent);
        return mainContent;
      })
      .catch(() => null);

    preloadCache.set(href, p);
    return p;
  };

  // ✅ NEW: set drawer header from loaded H1 + remove H1
  const setHeaderFromH1AndRemove = (drawer) => {
    // The header element you already have:
    const headerEl = drawer.querySelector('[slot="header"]'); // <span class="h5" slot="header">...</span>
    if (!headerEl) return;

    // Find first H1 inside drawer content
    const h1 = drawer.querySelector('h1');
    if (!h1) return;

    const title = (h1.textContent || '').trim();
    if (title) {
      headerEl.textContent = title;
    }

    // remove the H1 from body content
    h1.remove();
  };

  const openDrawerWithContent = async (content, activator) => {
    if (!content) return;

    await customElements.whenDefined('x-drawer');

    const drawer = getDrawer();
    if (!drawer) {
      console.warn('[Drawer] Missing <x-drawer id="' + DRAWER_ID + '"> in Liquid/HTML.');
      return;
    }

    // ✅ IMPORTANT: don't nuke the whole drawer or you'll lose slots
    // Put content in a body wrapper (create if missing)
    let bodyWrapper = drawer.querySelector('.prose.prose-justify-start');
    if (!bodyWrapper) {
      bodyWrapper = document.createElement('div');
      bodyWrapper.className = 'prose prose-justify-start';
      drawer.append(bodyWrapper);
    }

    bodyWrapper.innerHTML = content;

    // Extra safety clean after injection
    sanitizeRoot(bodyWrapper);

    // ✅ Set header from h1 and remove it
    setHeaderFromH1AndRemove(drawer);

    // Open
    if (typeof drawer.show === 'function') {
      drawer.show({ activator });
    } else {
      drawer.setAttribute('open', '');
    }
  };

  const handleLinkClick = (event, link) => {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const href = link.getAttribute('href');
    if (!isEligibleHref(href)) return;

    event.preventDefault();

    preloadContent(href).then((content) => {
      if (content) openDrawerWithContent(content, link);
      else window.location.assign(href);
    });
  };

  const setupLinks = () => {
    const blocks = document.querySelectorAll(BLOCK_SELECTOR);
    if (!blocks.length) return;

    const links = Array.from(blocks).flatMap((block) => Array.from(block.querySelectorAll('a[href]')));
    const uniqueLinks = Array.from(new Set(links));

    uniqueLinks.forEach((link) => {
      const href = link.getAttribute('href');
      if (!isEligibleHref(href)) return;

      preloadContent(href);
      link.addEventListener('click', (event) => handleLinkClick(event, link));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupLinks, { once: true });
  } else {
    setupLinks();
  }
})();
